import { useTranslation } from "react-i18next";

const useSkeyPoapData = () => {
  const { t } = useTranslation("skeyPoap");

  const data = [
    {
      img: {
        src: "/images/skeyPoap/skey-poap-features-1.png",
        alt: t("features.one.alt")
      },
      description: t("features.one.description")
    },
    {
      img: {
        src: "/images/skeyPoap/skey-poap-features-2.png",
        alt: t("features.two.alt")
      },
      description: t("features.two.description")
    },
    {
      img: {
        src: "/images/skeyPoap/skey-poap-features-3.png",
        alt: t("features.three.alt")
      },
      description: t("features.three.description")
    }
  ];

  return data;
};

export default useSkeyPoapData;
